<div class="container">
  <h2 i18n>Política de cookies</h2>
  <p i18n>
  política de cookies
  </p>
</div>
